import { render } from "./SentMessages.vue?vue&type=template&id=a518ac80&scoped=true"
import script from "./SentMessages.vue?vue&type=script&lang=js"
export * from "./SentMessages.vue?vue&type=script&lang=js"

import "./SentMessages.vue?vue&type=style&index=0&id=a518ac80&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a518ac80"]])

export default __exports__